
export default {

    methods: {

        log: function(message, lvl) {
            if (process.env.APP_DEBUG === false)
                return;

            switch(lvl) {
                case 'error':
                    console.error(message);
                    break;
                case 'debug':
                    console.debug(message);
                    break;
                case 'info':
                    console.info(message);
                    break;
                case 'warning':
                    console.warn(message);
                    break;
                default:
                    console.log(message);
            }
        },
    }
}
